import React from "react";
import Fade from "react-awesome-reveal";
// eslint-disable-next-line
import { UserCheck, Server, DollarSign, Briefcase } from "lucide-react";

export const TeamMembers = [
  {
    name: "Sheena Fraser",
    position: "CEO",
    icon: "UserCheck",
  },
  {
    name: "David Collier",
    position: "IT",
    icon: "UserCheck",
  },
  {
    name: "Anthony Williams",
    position: "Finance",
    icon: "UserCheck",
  },
  {
    name: "Tom Walkers",
    position: "Project Manager",
    icon: "UserCheck",
  },
];

// Mapping icon names to Lucide React components
const iconMap = {
  UserCheck,
  Server,
  DollarSign,
  Briefcase,
};

export default function AllTeam() {
  return (
    <section className="container px-4 mx-auto sm:px-0">
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-y-8 gap-x-8 sm:gap-14 lg:gap-10 justify-items-center">
        {TeamMembers.map((item) => {
          const IconComponent = iconMap[item.icon];
          return (
            <Fade
              bottom
              triggerOnce
              delay={200 * TeamMembers.indexOf(item)}
              key={item.name}
            >
              <div>
                <div className="flex flex-col justify-center transition duration-500 transform border border-purple-200 shadow-xl w-44 h-60 sm:w-56 sm:h-72 rounded-xl hover:scale-105">
                  <div className="flex justify-center xl:mb-5">
                    <IconComponent className="w-32 h-32 text-blue-600" />
                  </div>
                  <h2 className="text-xl text-center text-blue-800">
                    {item.name}
                  </h2>
                  <p className="mb-3 font-light text-center text-gray-400">
                    {item.position}
                  </p>
                </div>
              </div>
            </Fade>
          );
        })}
      </div>
    </section>
  );
}
